<template>
<div class="modalPopup-wrap" v-if="visibleStatus">
  <div class="contentWrap">
    <h2 class="title" v-show="type !=='edit'">항목 추가하기</h2>
    <div class="title editButtons" v-show="type==='edit'">
      <button @click="disabled = false" class="edit">수정하기</button>
      <button @click="tagInfoDelete" class="delete">삭제하기</button>
    </div>
    <div class="content">
      <ValidationText :status="tagTitle===''" addClass="name">
        <input v-model="tagTitle" type="text" :disabled="disabled" placeholder="항목을 추가해 주세요" />
      </ValidationText>
      <div class="desc">
        <textarea :readonly="disabled" v-model="tagContent" edita name="" id="" cols="" rows="" placeholder="내용을 입력해 주세요">
        </textarea>
        <div class="images">
          <label v-show="!imageUrl && !disabled" for="">
            <input type="file" @change="imageUpload" />
            이미지 추가하기
          </label>
          <img v-show="imageUrl" :src="imageUrl" alt="">
          <button v-show="imageUrl" class="imageDelete" @click="imageDelete">이미지 삭제</button>
        </div>
      </div>
    </div>
    <div class="ctrl buttons">
      <button v-show="type==='edit' && disabled==false" class="confirm" @click="merge">수정하기</button>
      <button v-show="type!=='edit'" class="confirm" @click="confirm">생성하기</button>
    </div>
    <button class="close" @click="hide">취소</button>
  </div>
</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import CommNew from "@processEditor/CommNew";
import ValidationText from '../../common/inputs/validationText.vue'

const ProcessEditor = createNamespacedHelpers('ProcessEditor');

export default {
  props: {
    visible: Boolean,
    tagInfo: Object,
    tagInfoId : String,
    type: {
      type: String,
      default() {
        return 'edit'
      }
    }
  },
  data () {
    return {
      imageUrl: false,
      tagContent: '',
      tagTitle: '',
      visibleStatus: false,
      disabled: false,
      nameValidation: true,
    }
  },
  mixins: [CommNew],
  components: {
    ValidationText
  },
  computed: {
    ...ProcessEditor.mapGetters(['getSelectedNode']),
  },
  watch: {
    visible (value) {
      // console.log("this.tagInfo",this.tagInfo)
      this.visibleStatus = value;
      if(value === false) {
        this.clear()
        return
      }
      if(this.type === 'edit') {
        this.tagTitle = this.tagInfo.tagTitle
        this.tagContent = this.tagInfo.tagContent
        this.imageUrl = this.tagInfo.tagImageUrl
        this.disabled=true
      } 
    },
    // tagInfoId(value) {
    //   console.log("Tag info id : ", value)
    //     this.tagInfo.tagInfoId = value;
    //     this.tagTitle = this.tagInfo.tagTitle
    //     this.tagContent = this.tagInfo.tagContent
    //     this.imageUrl = this.tagInfo.imageUrl
    //     // this.type='edit'
    //     this.disabled=true
    // },
  },
  mounted () {
    this.emitInterface()
  },
  methods : {
    emitInterface() {
      this.$emit('setMethod', {show : this.show, hide: this.hide});
    },
    clear () {
      this.tagInfo.tagInfoId = null;
      this.tagTitle = ''
      this.tagContent = null
      this.imageUrl = null
      this.disabled = false
    },
    async imageUpload(event) {
      let file = event.target.files[0]
      
      if(!file || !file.type.includes('image')) return;

      const formData = new FormData();
      formData.append('file', file)
      const imageInfo = await this.$wApi.file.post(formData)
      this.imageUrl = imageInfo.url
    },
    imageDelete () {
      this.imageUrl = false;
    },
    async confirm () {
      let tagInfo = this.getSelectedNode
      let data = {}
      if(!this.tagTitle || this.tagTitle === '') return
      if(!this.processId || !tagInfo) return
      data = {
        "processId":this.processId,
        "tagInfoId":this.tagInfoId,
        "key": tagInfo.key,
        "json":{
          "tag_content":this.tagContent,
          "tag_title": this.tagTitle,
          "tag_image_url":this.imageUrl || '',
        }
      }
      
      await this.$wApi.tag.info.put(data)
      this.$emit('itemUpdate', {
        "tag_content":this.tagContent,
        "tag_title": this.tagTitle,
        "tag_image_url":this.imageUrl || '',
      }, 'make')
      this.hide()
    },
    async merge () {
      let tagInfo = this.getSelectedNode
      let data = {}
      let json = {}

      if(!this.processId || !tagInfo) return
      data = {
        "processId":this.processId,
        "tagInfoId":this.tagInfoId,
        "key": tagInfo.key,
        "json":{
          "tag_content":this.tagContent,
          "tag_title": this.tagTitle,
          "tag_image_url":this.imageUrl || '',
        }
      }
      let tagInfoList = await this.$wApi.tag.info.put(data)
      this.$emit('itemUpdate',
        {
          "tag_content":this.tagContent,
          "tag_title": this.tagTitle,
          "tag_image_url":this.imageUrl || '',
        }
      , 'update')
      this.hide()
    },
    async tagInfoDelete (event) {
      let tagInfo = this.getSelectedNode, status = false
      try {
        await this.$wApi.tag.info.delete({
          "processId":this.processId,
          "tagInfoId":this.tagInfoId,
          "key": tagInfo.key,
        });
        status = true;
      }catch (error) {
        status = false;
      }
      this.$emit('itemDelete', status);
      this.hide()
    },
    show () {
      this.visibleStatus = false
      this.$emit('show');
    },
    hide () {
      this.visibleStatus = false
      this.disabled = false
      this.clear()
      this.$emit('hide');
    }

  }
}
</script>

<style lang="scss" scoped>
  .modalPopup-wrap {
    @include modalLayout();
    z-index: 100;
    .contentWrap {
      position: relative;
      min-width: 500px;
      padding: 24px;
      border: 1px solid #999;
      background-color: $white;
      &.edit {
        h2.title { visibility: hidden; }
      }
    }
  }
  .title {
    margin-bottom: 24px;
    line-height: 24px;
    font-size: 20px;
    @include text-prt-eb ;
  }
  input, textarea {
    width: 100%; min-height: 200px;
    padding: 8px;
    
  }
  input, .contents { border: 1px solid #999; }
  textarea { border: none; }
  .name {
    margin-bottom: var( --default-gap );
    input {
      display: block;
      width: 100%; min-height: 33px;
      border: 1px solid #999;
      @include text-prt-b ;
      &::placeholder {
        font-size: 14px; color: #ddd;
      }
    }
  }
  .desc {
    border: 1px solid #999;
    textarea {
      resize: none;
      height: 150px;
      @include text-prt-b ;
      &::placeholder {
        font-size: 14px; color: #ddd;
      }
    }
  }
  .buttons{
    gap: 10px;
    margin-top: var( --default-gap );
    button {
      padding: 8px var( --default-gap );
      @include text-prt-b ;
      border-radius: 4px;
      &.confirm {
        background: $dark-blue;
        color: $white;
      }
    }
  }
  .editButtons {
    display: flex; align-items: center; justify-content: flex-end;
    gap : 12px;
    margin: 2px 10px 0 0;
    button {
      width: 18px; height: 18px;
      background-size: cover;
      font-size: 0;
      &.edit { background: url('../../../assets/icons/icon-edit.svg') center no-repeat; }
      &.delete { background: url('../../../assets/icons/icon-trash.svg') center no-repeat; }
    }
  }
  
  .images {
    position: relative;
    margin: 8px;
    label {
      position: relative;    
      // width: 25px; height: 25px;
      padding: 4px 4px 4px 22px;
      background: url('../../../assets/icons/icon-image.svg') 0 center no-repeat;
      cursor: pointer;
      overflow: hidden;
      font-size: 12px;
      color: #999;
    }
    input[type='file'] {
      position: absolute; top:0; left:0; right:0; bottom:0;
      opacity: 0;
      cursor: pointer;
    }
    img {
      max-width: 100px; max-height: 100px;
      background-color: rgba(0,0,0, .3);
    }
    .imageDelete {
      position: absolute; top:-10px; left: -5px;
      width: 30px; height: 30px;
      border: 1px solid #333; border-radius: 50%;
      background: url('../../../assets/icons/icon-close.svg') center no-repeat;
      background-size: 15px;
      background-color: $white;
      font-size: 0;
    }
  }
</style>